import {ActivityCommonProperties} from "../../types-enums/activity-common-properties";
import {relevantErrorCodes} from "../../api/model/common";
import {DateTime} from "luxon";

/**
 * Retrieves the domain portion of the current URL from the browser's window location.
 *
 * The function parses the complete URL and extracts the protocol and domain name,
 * omitting the path, query parameters, or hash fragments.
 *
 * @returns {string} A string representing the protocol and domain of the current URL.
 */
export const _getDomain = (): string => {
    const domainName = window.location.href.split("/")
    return domainName[0] + "//" + domainName[2]
}

export interface ChooseActivityCommonProps {
    day: ActivityCommonProperties["common"]["day"],
    isEdit: boolean,
    resetForm: () => void
    useGroupId?: boolean | undefined,
    maxPersons: number | null
}

export interface ChooseActivityWithDateCommonProps {
    minDate?: DateTime
    maxDate?: DateTime
    openToDate?: DateTime
}

/**
 * Generates a formatted error code string based on the provided key.
 *
 * @param {keyof typeof relevantErrorCodes} code - The key representing an error code within the relevantErrorCodes object.
 * @returns {string} The formatted error code string in the `ERRORS.BACKEND_ERROR_CODES.<errorCode>` format.
 */
export const createErrorCodeString = (code: keyof typeof relevantErrorCodes): string => `ERRORS.BACKEND_ERROR_CODES.${relevantErrorCodes[code]}`
